export const getRole = () => {
  return localStorage.getItem("role");
};
export const getPermissions = () => {
  const stored = localStorage.getItem("permissions");
  try {
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    return {};
  }
};

const normalizePermissionKey = (key) =>
  String(key || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

export const hasPermission = (key) => {
  const role = getRole();
  const permissions = getPermissions();
  // SUPER_ADMIN → Always true
  if (role === "SUPER_ADMIN") return true;

  const permission = Object.entries(permissions).find(
    ([permissionName]) =>
      normalizePermissionKey(permissionName) === normalizePermissionKey(key)
  )?.[1];

  return permission === true || permission?.enabled === true;
};
